var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 30,
    viewBox: "0 0 22 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.90002 9.95215H20.455",
    stroke: "#FCC436",
    strokeWidth: 2.65071,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65212 11.3719C4.59731 10.6048 5.20499 9.95215 5.97416 9.95215H16.3809C17.15 9.95215 17.7577 10.6048 17.7029 11.3719L16.5669 27.2762C16.5173 27.9698 15.9402 28.5071 15.2449 28.5071H7.11013C6.41484 28.5071 5.83772 27.9698 5.78815 27.2762L4.65212 11.3719Z",
    stroke: "#FCC436",
    strokeWidth: 2.65071
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1775 5.97607V3.32536C11.1775 2.59338 11.7709 2 12.5028 2H14.4909",
    stroke: "#FCC436",
    strokeWidth: 2.65071,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0289 7.08348C5.1354 6.44439 5.68834 5.97601 6.33624 5.97601H16.0189C16.6668 5.97601 17.2197 6.44439 17.3262 7.08348L17.8044 9.95208H4.55078L5.0289 7.08348Z",
    fill: "#FCC436",
    stroke: "#FCC436",
    strokeWidth: 2.65071
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShake);
export default __webpack_public_path__ + "static/media/shake.b572513f5a3d6f536a126f1662249e06.svg";
export { ForwardRef as ReactComponent };